module.exports = __webpack_public_path__ + "img/magnifier.c0704e26.svg";